/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';
import { OrderedMap, Map } from 'immutable';
import isString from 'lodash.isstring';
import escapeRegExp from 'lodash.escaperegexp';

export const templatesMap = getterFromKeyPath(['subscriptions', 'templates']);
export const subscriptionsMap = getterFromKeyPath(['subscriptions', 'subscriptions']);
export const loading = getterFromKeyPath(['subscriptions', 'loading']);
export const displayOptions = getterFromKeyPath(['subscriptions', 'options']);

export const templates = createSelector(
  [ templatesMap, displayOptions ],
  (subs: OrderedMap<any, any>, options: Map<any, any>) => {
    let result = subs;

    const query = options.get('query');
    if (query) {
      result = result.filter(enclave => {
        const regex = new RegExp(escapeRegExp(query), 'i');

        // Test all top-level string values
        return enclave
          .valueSeq()
          .filter(isString)
          .some(x => x.search(regex) > -1);
      });
    }
    return result.toList();
  },
);

export const template = (id: string) => {
  return createSelector(
    templatesMap,
    (templates: OrderedMap<any, any>) => templates.get(id),
  );
};

export const subscription = (id: string) => createSelector(
  subscriptionsMap,
  (enclaves) => {
    return enclaves.get(id);
  }
);

/* Generate initial form values for save/edit enclave subscription modal */
export const getSubscriptionFormValues = (id: string) => createSelector(
  subscription(id),
  (sub) => {
    return sub.get('credentials');
  }
);



// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/getters.js